<script>
	import Widget from './Widget.svelte';

	const menu = [
		{label: 'Offerte', scroll: 'quotation', icon: 'circle-info', active: true},
		{label: 'Specificatie', scroll: 'specification', icon: 'circle-check'},
		{label: 'Voorbeeld', scroll: 'images', icon: 'circle-camera'}
	];
</script>

<Widget menu="{menu}" title="Offerte"/>